import { render, staticRenderFns } from "./HeaderCardModern.vue?vue&type=template&id=a6d3dda8&scoped=true&"
import script from "./HeaderCardModern.vue?vue&type=script&lang=js&"
export * from "./HeaderCardModern.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCardModern.vue?vue&type=style&index=0&id=a6d3dda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d3dda8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
